import { FC, ReactNode } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

interface NewsletterFormEmbeddedPageLayoutProps {
  children: ReactNode;
}

export const NewsletterFormEmbeddedPageLayout: FC<NewsletterFormEmbeddedPageLayoutProps> = ({ children }) => {
  return (
    <Box
      sx={{
        padding: 0,
        height: "100%",
        flex: 1,
        display: "flex",
      }}
    >
      <Stack direction="column" gap={{ xs: 2, md: 3 }} alignItems="start" justifyContent="start" width="100%">
        {children}
      </Stack>
    </Box>
  );
};
